import { ref } from 'vue';

type TUseDropdownVisibleChange = {
  emit: (event: 'change' | 'visibleChange', ...args: unknown[]) => void,
};

export const useDropdownVisibleChange = ({ emit }: TUseDropdownVisibleChange) => {
  const isDropdownVisible = ref(false);

  const onDropdownVisibleChange = (isVisible: boolean) => {
    isDropdownVisible.value = isVisible;

    emit('visibleChange', isVisible);
  };

  return {
    isDropdownVisible,

    onDropdownVisibleChange,
  };
};
